import type { RtoSlice } from "@estelle/domain";

/** A courier or state needs this many finished shipments to be rated alone (#638). */
export const RTO_MIN_SHIPMENTS = 10;

export interface GroupedRto {
  /** Couriers or states with enough shipments to rate on their own. */
  rated: RtoSlice[];
  /** The rest, added together, or null when there is no rest. */
  other: (RtoSlice & { members: number }) | null;
}

/**
 * Splits RTO rows into those with at least `min` finished shipments and one
 * "Other" row adding up the rest (#638). Five couriers at 0% from four parcels
 * each said nothing; one "Other" line with its own count says what is known.
 */
export function groupRto(
  rows: readonly RtoSlice[],
  min = RTO_MIN_SHIPMENTS,
): GroupedRto {
  const rated: RtoSlice[] = [];
  let rto = 0;
  let outcomes = 0;
  let members = 0;
  for (const row of rows) {
    if (row.outcomes >= min) {
      rated.push(row);
    } else {
      rto += row.rto;
      outcomes += row.outcomes;
      members += 1;
    }
  }
  return {
    rated,
    other: members === 0 ? null : { key: "Other", rto, outcomes, members },
  };
}
